import React from 'react'
import { Skeleton, Box, Stack } from '@mui/material'

const SkeletonCard = () => {
  return (
    <Box sx={{ p: 2, maxWidth: 600, borderRadius: 2 }}>
      <Skeleton height={30} width="50%" />

      <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
        <Skeleton variant="rectangular" height={30} width={70} />
        <Skeleton variant="rectangular" height={30} width={70} />
      </Box>

      <Stack spacing={1} sx={{ mt: 2 }}>
        <Skeleton height={20} width="100%" />
        <Skeleton height={20} width="80%" />
        <Skeleton height={20} width="60%" />
      </Stack>

      <Box sx={{ mt: 2 }}>
        <Skeleton height={25} width="30%" />
        <Skeleton height={20} width="80%" />
        <Skeleton height={20} width="50%" />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Skeleton height={25} width="30%" />
        <Skeleton height={20} width="80%" />
        <Skeleton height={20} width="50%" />
      </Box>
    </Box>
  )
}

export default SkeletonCard
